export default "__VITE_ASSET__1d7a30e5__"